import { useContext } from 'preact/hooks'
import BaseContext from 'contexts/base-context'
import { useParentWindowSize } from 'scripts/hooks'

export type HorizontalPaddingMode = 'normal' | 'compact'

export const defaultHorizontalPadding = { normal: 24, compact: 20 }

const useHorizontalPadding = () => {
  const { windowSizeSm } = useParentWindowSize()
  const { forcePlatformAs } = useContext(BaseContext)
  const horizontalPaddingMode = windowSizeSm || forcePlatformAs === 'mobile' ? 'compact' : 'normal'
  return defaultHorizontalPadding[horizontalPaddingMode]
}

export default useHorizontalPadding
